module.exports = __webpack_public_path__ + "img/exam4.e082eb45.png";